// ============================================================
// OS ENUMS DO VÍNCULO COM A GENESIS (Story 38.4, issue #690), num módulo sem imports
// de valores.
//
// `dtos.ts` usa-os nos corpos da alocação (Story 38.5: o regime do vínculo que abre ao
// alocar, e o motivo do desligamento ao encerrar). Declarados em `genesis-bonds.ts`, que
// importa `ContractDateSchema` de `dtos.ts`, fechariam um ciclo de valores, e o
// carregamento do pacote daria ReferenceError. `genesis-bonds.ts` reexporta-os.
// ============================================================
import type { CONTRACT_TYPES } from './dtos'

/**
 * O regime efetivo do vínculo: o que a pessoa aceita (`CONTRACT_TYPES`) sem «os
 * dois» — o vínculo é um regime só. `@caliber/db` tem a mesma lista.
 */
export const BOND_CONTRACT_TYPES = ['clt', 'pj'] as const satisfies readonly Exclude<
  (typeof CONTRACT_TYPES)[number],
  'both'
>[]
export type BondContractType = (typeof BOND_CONTRACT_TYPES)[number]

/**
 * A categoria do desligamento. Fechada, e não texto livre: o detalhe fica no RH, e
 * um campo livre que toda a Genesis lê puxaria dado sensível (saúde, disciplina).
 * `@caliber/db` tem a mesma lista.
 */
export const BOND_END_REASONS = [
  'resignation',
  'dismissal',
  'contract_end',
  'regime_change',
  'opened_by_mistake',
  'other',
] as const
export type BondEndReason = (typeof BOND_END_REASONS)[number]
